module.exports = {"name":"cardBackPUpLink","audiences":["alphaMembers","allMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":0.1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"showGetPups":false},"variations":[{"name":"showPupLink","values":{"showGetPups":true},"weight":1}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/cardBackPUpLink.json
// module id = hGcI
// module chunks = 1